import React, { useState } from "react";
import ReactModal from "react-modal";
import close from "../../../Assets/closeIcon.svg";
import incorrectAnswer from "../../../Assets/incorrectAnswer.png";
import incorrectAnsweractive from "../../../Assets/incorrectAnsweractive.png";
import correctanswer from "../../../Assets/correctanswer.png";
import correctansweractive from "../../../Assets/correctansweractive.png";
import { useDispatch } from "react-redux";
import { updateQUestionFeedback } from "../../../Redux/Reducer/FormSlices";

const FeedBackModal = ({
  isOpen,
  onClose,
  onChange,
  showCorrect,
  setShowCorrect,
  answerFeedback,
  type,
}) => {
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      borderRadius: "15px",
      transform: "translate(-50%, -50%)",
      width: "40%",
      height: "37%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "Space-between",
      padding: "px !important",
      backgroundColor: "#ffffff",
    },
    overlay: {
      background: "rgba(0,0,0,0.25)",
    },
  };



  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={() => onClose()}
      style={customStyles}
    >
      <div className="feedback-modal-main-container">
        <div className="feedback-modal-main-container-top">
          <div>Add feedback</div>
          <img src={close} alt="" onClick={() => console.log("sdfghjkl;")} />
        </div>
        {type === "shortAnswer" || type === "paragraph" ? (
          <></>
        ) : (
          <div className="container-crt-wong-ans">
            <div className="answer-containerchoise">
              <img
                src={
                  showCorrect === "Incorrect answer"
                    ? incorrectAnsweractive
                    : incorrectAnswer
                }
                alt="incorrectAnswer"
              />
              <div
                style={{
                  color:
                    showCorrect === "Incorrect answer" ? "#1B51BB" : "#8493B2",
                  fontFamily: "EuclidSemiBold",
                }}
                onClick={() => setShowCorrect("Incorrect answer")}
              >
                Incorrect answer
              </div>
            </div>
            <div className="answer-containerchoise">
              <img
                src={
                  showCorrect === "Correct answer"
                    ? correctansweractive
                    : correctanswer
                }
                alt="correctanswer"
              />
              <div
                style={{
                  color:
                    showCorrect === "Correct answer" ? "#1B51BB" : "#8493B2",
                  fontFamily: "EuclidSemiBold",
                }}
                onClick={() => setShowCorrect("Correct answer")}
              >
                Correct answer
              </div>
            </div>
          </div>
        )}
        {type === "paragraph" || type === "shortAnswer" ? (
          <textarea
            className="correctAnswerInput-modal"
            name="feedBack"
            value={answerFeedback.feedBack}
            onChange={onChange}
          />
        ) : (
          <textarea
            className="correctAnswerInput-modal"
            name={
              showCorrect === "Incorrect answer"
                ? "inCurrentAnswerFeedback"
                : "currentAnswerFeedback"
            }
            value={
              showCorrect === "Incorrect answer"
                ? answerFeedback.inCurrentAnswerFeedback || ""
                : answerFeedback.currentAnswerFeedback || ""
            }
            onChange={onChange}
          />
        )}
        <div className="correctAnswerInput-modal-button-container">
          <button
            className="correctAnswerInput-modal-button-container-btn-cancel"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="correctAnswerInput-modal-button-container-btn-save"
            onClick={onClose}
          >
            Save
          </button>
        </div>
      </div>
    </ReactModal>
  );
};

export default FeedBackModal;
